/* eslint-disable prettier/prettier */
import styled from 'styled-components';

export const StyledMIButtonWrapper = styled.div<{ isError?: boolean }>`
  button {
    padding: ${({ isError }) => (isError ? '0 13px' : '0 16px')};
    white-space: nowrap;
  }
  @media (max-width: 1200px) {
    button {
      width: 100%;
      padding: 0 5px;
      font-size: 0.723rem;
    }
  }
`;

export const StyledMIMenuButtonWrapper = styled.div`
  button {
    padding: 0 5px;
    white-space: nowrap;
  }
`;
